export const NAMESPACE = 'properties'
